import { walletInfoCurrentSelectedWallet } from '@/state/userInfo';
import {
  MoonCryptoTokenEth2,
  MoonCryptoTokenUsdc,
  MoonCryptoTokenUsdt,
  MoonCryptoTokenDoge,
  MoonCryptoTokenBtc,
  MoonCryptoTokenBnb,
  MoonCryptoTokenTrx,
  MoonCryptoTokenAvax,
  MoonCryptoTokenBch,
  MoonCryptoTokenChz,
  MoonCryptoTokenDaii,
  MoonCryptoTokenMatic,
} from '@crownbit/icons';
import { useAtom, useAtomValue } from 'jotai';

interface TokenIconProps {
  style?: Record<string, any>;
  fontSize?: 'inherit' | 'small' | 'medium' | 'large';
  currency?: string;
}

export function TokenIcon({
  style = {},
  fontSize = 'small',
  currency,
}: TokenIconProps = {}) {
  const currentSelectedWallet = useAtomValue(walletInfoCurrentSelectedWallet);
  if (!currency) {
    currency = currentSelectedWallet?.coin || 'usdt';
  }
  switch (currency.toLowerCase()) {
    case 'usdt':
      return <MoonCryptoTokenUsdt style={style} fontSize={fontSize} />;
    case 'usdc':
      return <MoonCryptoTokenUsdc style={style} fontSize={fontSize} />;
    case 'eth':
      return <MoonCryptoTokenEth2 style={style} fontSize={fontSize} />;
    case 'doge':
      return <MoonCryptoTokenDoge style={style} fontSize={fontSize} />;
    case 'btc':
      return <MoonCryptoTokenBtc style={style} fontSize={fontSize} />;
    case 'bnb':
      return <MoonCryptoTokenBnb style={style} fontSize={fontSize} />;
    case 'trx':
      return <MoonCryptoTokenTrx style={style} fontSize={fontSize} />;
    case 'avax':
      return <MoonCryptoTokenAvax style={style} fontSize={fontSize} />;
    case 'bch':
      return <MoonCryptoTokenBch style={style} fontSize={fontSize} />;
    case 'chz':
      return <MoonCryptoTokenChz style={style} fontSize={fontSize} />;
    case 'daii':
      return <MoonCryptoTokenDaii style={style} fontSize={fontSize} />;
    case 'matic':
      return <MoonCryptoTokenMatic style={style} fontSize={fontSize} />;
    default:
      return <MoonCryptoTokenUsdt style={style} fontSize={fontSize} />;
  }
}

export function StyledTokenIcon({
  fontSize = 'small',
  currency,
}: TokenIconProps = {}) {
  return <TokenIcon fontSize={fontSize} currency={currency} />;
}
